const overviewComponent = [
  {
    title: 'Accordion',
    description: 'An element that can expand/collapse to reveal or hide more associated content',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/accordion.svg',
    link: '/components/accordion/website',
    website: true,
    ios: true,
    android: true,
  },
  {
    title: 'Alert',
    description: 'Displays a message to the user for important information or warning purposes',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/alert.svg',
    link: '/components/alert/website',
    website: true,
    android: true,
  },
  {
    title: 'Anchor Text',
    description: 'Actionable text link trigger for user to navigate or use as tertiary call to action',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/anchor.svg',
    link: '/components/anchor/guideline',
    android: true,
    website: true,
  },
  {
    title: 'Avatar',
    description: 'Graphical interface to a visual representation of a user, entity or profile',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/avatar.svg',
    link: '/components/avatar/guideline',
    website: true,
    ios: true,
  },
  {
    title: 'Badge',
    description: 'The visual indicator for the values such as labeling or notification',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/badge.svg',
    link: '/components/badge/guideline',
    website: true,
  },
  {
    title: 'Bottom Sheet',
    description: 'The bottom sheet is a slides from the bottom of the screen',
    image:
      'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/bottomsheet/guideline/bottom-sheet-component-hero.svg',
    link: '/components/bottomsheet/guideline',
    ios: true,
  },
  {
    title: 'Box',
    description: 'Hold other elements, and can be styled to adjust its position, size, and layout',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/box.svg',
    link: '/components/box/website',
    website: true,
  },
  {
    title: 'Button',
    description: 'The visual indicator for the values such as labeling or notification',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/button.svg',
    link: '/components/button/guideline',
    website: true,
    android: true,
    ios: true,
  },
  {
    title: 'Card',
    description: 'A container, wrap or shell for content representing a single entity',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/card.svg',
    link: '/components/card/guideline',
    website: true,
  },
  {
    title: 'Carousel',
    description: 'Carousel used for advertising that allows marketers to place more than 1 image in a post',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/carousel/carousel-hero.svg',
    link: '/components/carousel/guideline',
    website: true,
  },
  {
    title: 'Checkbox',
    description: 'Allow users to selected multiple optional items or selected option agreements',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/chekbox.svg',
    link: '/components/checkbox/guideline',
    website: true,
    android: true,
    ios: true,
  },
  {
    title: 'Chips',
    description: 'Allow users to enter information, make selections, filter content, or trigger actions',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/chips.svg',
    link: '/components/chips/guideline',
    website: true,
    android: true,
    ios: true,
  },
  {
    title: 'Datepicker',
    description: 'Allow users to pick date',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/datepicker.svg',
    link: '/components/datepicker/guideline',
    website: true,
  },
  {
    title: 'Divider',
    description: 'Line should be used to bring clarity and structure to a layout, section and content',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/divider.svg',
    link: '/components/divider/guideline',
    website: true,
    android: true,
  },
  {
    title: 'Dropdown',
    description: 'Selecting a value when expanded can shows a list option',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/dropdown.svg',
    link: '/components/dropdown/guideline',
    website: true,
  },
  {
    title: 'Flex',
    description: 'Enables flexible layouts for its child elements, allowing for dynamic and responsive design',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/flex.svg',
    link: '/components/flex/website',
    website: true,
  },
  {
    title: 'Grid',
    description: 'Enabling precise control over placement and alignment of its child elements',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/grid.svg',
    link: '/components/grid/website',
    website: true,
  },
  {
    title: 'Image',
    description: 'A visual representation of something',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/image.svg',
    link: '/components/image/guideline',
    website: true,
    android: true,
  },
  {
    title: 'Mega Menu',
    description: 'Mega menu are to display a list of options on a temporary surface',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/megamenu/megamenu-hero.svg',
    link: '/components/megamenu/website',
    website: true,
  },
  {
    title: 'Modal',
    description: 'Modal Lorem ipsum dolor sit amet.',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/component/modal/modal-hero.svg',
    link: '/components/modal/guideline',
    website: true,
  },
  {
    title: 'Navigation Bar',
    description: 'Navigation elements are displayed at the top of the screen',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/navigationbar.svg',
    link: '/components/navigationbar/website',
    website: true,
  },
  {
    title: 'Radio Button',
    description: 'For users select one option from list of group option',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/radiobutton.svg',
    link: '/components/radiobutton/guideline',
    ios: true,
    android: true,
  },
  {
    title: 'Snackbar',
    description: 'Inform feedback to the users result of the process or action executed',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/snackbar.svg',
    link: '/components/snackbar/guideline',
    android: true,
    ios: true,
  },
  {
    title: 'Select Field',
    description: 'For selecting a value when expanded can shows a list of options',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/selectfield.svg',
    link: '/components/selectfield/guideline',
    website: true,
  },
  {
    title: 'Sidebar',
    description: 'Vertical side component that supports navigational elements',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/sidebar.svg',
    link: '/components/sidebar/website',
    website: true,
  },
  {
    title: 'Spinner',
    description: 'Animated spinning icon that lets users know content is being loaded',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/spin.svg',
    link: '/components/spinner/guideline',
    website: true,
  },
  // {
  //   title: 'Stepper',
  //   description: 'Step by step description that lets users know actions need to be done',
  //   image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/spin.svg',
  //   link: '/components/stepper/website',
  //   website: true,
  // },
  {
    title: 'Switch',
    description: 'Allow users to offers a control to switch the toggle items setting on or off',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/switch.svg',
    link: '/components/switch/guideline',
    website: true,
    ios: true,
    android: true,
  },
  // {
  //   title: 'Tab Bar',
  //   description: 'For displaying large amounts of data inside the rows and columns',
  //   image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/table.svg',
  //   link: '/components/tabBar/website',
  //   website: true,
  // },
  {
    title: 'Table',
    description: 'For displaying large amounts of data inside the rows and columns',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/table.svg',
    link: '/components/table/guideline',
    website: true,
  },
  {
    title: 'Textarea',
    description: 'Enable the user to interact with long form text which spans over multiple lines',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/area.svg',
    link: '/components/textarea/guideline',
    website: true,
    android: true,
    ios: true,
  },
  {
    title: 'Textfield',
    description: 'Enable the user to interact with spesific input content, value or data',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/field.svg',
    link: '/components/textfield/guideline',
    website: true,
    android: true,
    ios: true,
  },
  {
    title: 'Tooltip',
    description: 'Shows additional context on tap, focus or hover to help give more information in the interaction',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/tooltip.svg',
    link: '/components/tooltip/guideline',
    website: true,
  },
  {
    title: 'View State',
    description: 'Stores and updates data related to the current state of a view.',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/component/viewstate.svg',
    link: '/components/viewstate/android',
    android: true,
  },
];

const overviewFoundation = [
  {
    title: 'Accessibility',
    description: 'Focuses on enabling access for inclusive people, enabling access through the use of technology',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/foundation/Access.svg',
    link: '/foundation/accessibility',
  },
  {
    title: 'Color System',
    description: 'Color distinguishes for brand and helps to create consistent experiences across products',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/foundation/color.svg',
    link: '/foundation/color-system/website',
  },
  {
    title: 'Typography',
    description: 'Typography is used critical for communicating the hierarchy content and cotext of a page',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/foundation/typo.svg',
    link: '/foundation/typography/website',
  },
  {
    title: 'Spacing',
    description: 'Horizontal and vertical distances between components or the viewpoints of the layout screen',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/foundation/Spacing.svg',
    link: '/foundation/spacer/website',
  },
  {
    title: 'Radius',
    description: "Rounds the corners of element's or component outer border edge with impact to style of brand",
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/foundation/Radius.svg',
    link: '/foundation/radius/website',
  },
  {
    title: 'Elevation',
    description: 'Visual cues in the interface which tell human brains what user interface elements looking at',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/foundation/Elevation.svg',
    link: '/foundation/elevation',
  },
];

const overviewPattern = [
  {
    title: 'Login & Register',
    description: 'General login process flow such as the register page, forgot password and set new password',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/pattern/login-overview.svg',
    link: '/pattern/login-and-register/website',
    android: true,
    website: true,
  },
  {
    title: 'On Boarding',
    description: 'General on boarding process flow such as the splash screen page until the home or login page',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/pattern/onboarding-overview.svg',
    link: '/pattern/onboarding/mobile',
    android: true,
  },
];

const overviewContent = [
  {
    title: 'Writing Principles',
    description: 'Use these guidelines as a source of truth, for best practices and patterns when writing messages.',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/content/writing-principle.svg',
    link: '/content/writing-principles/website',
  },
  {
    title: 'Mechanics',
    description: 'General on boarding process flow such as the splash screen page until the home or login page',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/content/mechanics.svg',
    link: '/content/mechanics/website',
  },
  {
    title: 'Grammar',
    description: 'Use these guidelines as a source of truth, for best practices and patterns when writing messages',
    image: 'https://teddys-minio-teddys-dev.vsan-apps.playcourt.id/legion/overview/content/grammar.svg',
    link: '/content/grammar/website',
  },
];

export { overviewComponent, overviewFoundation, overviewPattern, overviewContent };
